export default __webpack_public_path__ + "static/media/thankyoukeyvis_voucher50_tab@2x.08e8fc87.png";